
/*@jsxRuntime automatic @jsxImportSource react*/
/*prettier-ignore*/
/*prettier-ignore*/
/*prettier-ignore*/
/*prettier-ignore*/
/*prettier-ignore*/
/*prettier-ignore*/
export const attributes = {
  "authors": ["ben-milne", "chase-merlin"],
  "callToAction": {
    "heading": "Get started",
    "subheading": "Open an account in 10 minutes or less.",
    "button": "Open account",
    "ctaUrl": "https://app.brale.xyz/buy/signup",
    "externalUrl": true
  },
  "coverImage": {
    "alt": "Introducing Brale Business Accounts | Brale Blog",
    "url": "/assets/blog/introducing-brale-business-accounts/cover.svg"
  },
  "date": "2024-07-25",
  "description": "Brale gives businesses access to popular stablecoins through a unified platform. Onramp, offramp, and swap stablecoins without any fees.",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_introducing-brale-business-accounts-brale-activity-7222269706236305410-MMiy/",
  "discussTwitter": "https://x.com/brale_xyz/status/1816504200601235775",
  "discussFarcaster": "https://warpcast.com/brale/0x77cad710",
  "excerpt": "Introducing Brale Business Accounts - access popular stablecoins and run your business onchain. Onramp, offramp, and swap stablecoins without fees.",
  "ogImage": {
    "alt": "Introducing Brale Business Accounts | Brale Blog",
    "url": "/assets/blog/introducing-brale-business-accounts/og-image.png"
  },
  "timeOverride": 5,
  "title": "Introducing Brale Business Accounts",
  "fees": {
    "offchain": [{
      "type": "Wire",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "ACH",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }],
    "onchain": [{
      "type": "USDC",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "USDP",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "PYUSD",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }]
  },
  "flows": [{
    "stable": "USDC"
  }, {
    "stable": "USDP"
  }, {
    "stable": "PYUSD"
  }, {
    "stable": "SBC"
  }, {
    "stable": "USDGLO"
  }, {
    "stable": "USC"
  }],
  "slippage": [{
    "size": "$2,000",
    "slippage": ".10%",
    "cost": "$2"
  }, {
    "size": "$2,000",
    "slippage": ".20%",
    "cost": "$4"
  }, {
    "size": "$2,000",
    "slippage": "1%",
    "cost": "$20"
  }],
  "swap": [{
    "in": "USD",
    "out": "USDC",
    "fixedCost": "$0.00",
    "bpCost": "0%"
  }, {
    "in": "USDC",
    "out": "USD",
    "fixedCost": "$0.00",
    "bpCost": "0%"
  }, {
    "in": "USD",
    "out": "USDP",
    "fixedCost": "$0.00",
    "bpCost": "0%"
  }, {
    "in": "USDP",
    "out": "USD",
    "fixedCost": "$0.00",
    "bpCost": "0%"
  }, {
    "in": "USDP",
    "out": "USDC",
    "fixedCost": "$0.00",
    "bpCost": "0%"
  }, {
    "in": "USD",
    "out": "SBC",
    "fixedCost": "$0.00",
    "bpCost": "0%"
  }, {
    "in": "SBC",
    "out": "USD",
    "fixedCost": "$0.00",
    "bpCost": "0%"
  }],
  "slider": {
    "slides": [{
      "image": "/assets/blog/rain-cards/rain-slide-01.png",
      "alt": "Rain Transaction Details UI for Freehand Hotel transaction | Brale"
    }, {
      "image": "/assets/blog/rain-cards/rain-slide-02.png",
      "alt": "Rain Transaction Details UI for Adventureland Resort transaction | Brale"
    }, {
      "image": "/assets/blog/rain-cards/rain-slide-03.png",
      "alt": "Rain Transaction Details UI for Dunkin' transaction | Brale"
    }, {
      "image": "/assets/blog/rain-cards/rain-slide-04.png",
      "alt": "Rain Transaction Details UI for downtown Des Moines parking meter transaction | Brale"
    }],
    "settings": {
      "adaptiveHeight": true,
      "arrows": false,
      "autoplay": true,
      "autoplaySpeed": 7500,
      "dots": true,
      "fade": true,
      "infinite": true,
      "draggable": true
    }
  },
  "pricing": [{
    "item": "Monthly fee",
    "price": "$0"
  }, {
    "item": "Minimum balance",
    "price": "$0"
  }, {
    "item": "Sending & receiving stablecoins",
    "price": "$0*"
  }, {
    "item": "Fee per seat",
    "price": "$0"
  }, {
    "item": "Individual swap fee",
    "price": "$0"
  }, {
    "item": "ACH deposit fee",
    "price": "$0"
  }, {
    "item": "ACH withdraw fee",
    "price": "$0"
  }, {
    "item": "Automations",
    "price": "Contact us for beta"
  }, {
    "item": "API access",
    "price": "$0"
  }, {
    "item": "Bookkeeper access",
    "price": "$0"
  }]
};
import {faArrowRight, faArrowRightFromArc, faArrowRightToArc, faCircleDollar} from "@fortawesome/pro-light-svg-icons";
import {BLOCKCHAINS} from "~/lib/ecosystem";
import {ExternalLink} from "~/components/site/external-link";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ImageSlider} from "~/components/blog/slider";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    img: "img",
    tr: "tr",
    td: "td",
    div: "div",
    span: "span",
    strong: "strong",
    a: "a"
  }, props.components);
  return <><_components.p>{"Business accounts are a simple way for businesses around the country to use popular stablecoins without the challenges of tying together multiple solutions."}</_components.p>{"\n"}<_components.p>{"Business accounts boast an easy UI for managing stablecoins across blockchains and a familiar interface for depositing and withdrawing USD to your bank account. They also abstract all of the complexity of using blockchains and there are no pre-funding accounts for gas fees or any of that stress."}</_components.p>{"\n"}<_components.p>{"Business accounts have everything you'd expect with incredible pricing to match."}</_components.p>{"\n"}<_components.h2>{"Onramp and offramp built-in"}</_components.h2>{"\n"}{}{"\n"}<div className="round border border-primary not-prose my-10 bg-black overflow-clip flex justify-center"><_components.p><_components.img src="/assets/blog/introducing-brale-business-accounts/deposit-flow.gif" alt="Brale Business Account UI minting USDGLO via ACH transfer" /></_components.p></div>{"\n"}{}{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 w-full text-base"><thead><tr><th className="px-4 w-1/3" /><th className="px-4 w-1/3"><span className="whitespace-nowrap">{"Deposit Fee"}</span>{" (Onramp)"}</th><th className="px-4 w-1/3"><span className="whitespace-nowrap">{"Withdraw Fee"}</span>{" (Offramp)"}</th></tr></thead><tbody><tr><td className="px-4 whitespace-nowrap"><strong>{"Offchain"}</strong></td><td className="px-4" /><td className="px-4" /></tr>{attributes.fees.offchain.map(f => <_components.tr key={f.type}>
          <_components.td className="px-4">{f.type}</_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
        </_components.tr>)}<tr><td className="px-4 whitespace-nowrap"><strong>{"Onchain"}</strong></td><td className="px-4" /><td className="px-4" /></tr>{attributes.fees.onchain.map(f => <_components.tr key={f.type}>
          <_components.td className="px-4">
            <_components.img alt={`${f.type} logo`} src={`/assets/stablecoins/${f.type.toLowerCase()}-logo.png`} className="h-6 w-6 inline-block !mr-2" />
            {f.type}</_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"Flows supported in the onramp/offramp are:"}</_components.p>{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 w-full text-base"><tbody>{attributes.flows.map(f => <_components.tr key={f.stable}>
          <_components.td className="px-4 w-1/5 whitespace-nowrap">
            <_components.div className="flex items-center">
              <FontAwesomeIcon icon={faCircleDollar} className="mr-2 text-green-600 dark:text-green-500 h-6 w-6" />
              <_components.span>USD</_components.span>
            </_components.div>
          </_components.td>
          <_components.td className="px-4 w-1/5 align-middle text-center">
            <FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" />
          </_components.td>
          <_components.td className="px-8 w-1/5 whitespace-nowrap text-primary">
            <_components.div className="flex items-center justify-center">
              <_components.img alt={`${f.stable} logo`} src={`/assets/stablecoins/${f.stable.toLowerCase()}-logo.png`} className="h-6 w-6 inline-block !mr-2" />
              <_components.strong>{f.stable}</_components.strong>
            </_components.div>
          </_components.td>
          <_components.td className="px-4 w-1/5 align-middle text-center">
            <FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" />
          </_components.td>
          <_components.td className="px-4 w-1/5 whitespace-nowrap">
            <_components.div className="flex items-center justify-end">
              <FontAwesomeIcon icon={faCircleDollar} className="mr-2 text-green-600 dark:text-green-500 h-6 w-6" />
              <_components.span>USD</_components.span>
            </_components.div>
          </_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.h2>{"Zero slippage swaps"}</_components.h2>{"\n"}<_components.p>{"Swap $1,000 in one stablecoin, get $1,000 in the other stablecoin. It's that simple."}</_components.p>{"\n"}{}{"\n"}<div className="round border border-primary not-prose my-10 bg-gray-100 dark:bg-black overflow-clip"><_components.p><_components.img src="/assets/blog/introducing-brale-business-accounts/swap-stablecoins.gif" alt="Brale UI showing swap between Stable Coin (SBC) and Glo Dollar (USDGLO)" /></_components.p></div>{"\n"}<_components.p>{"When using decentralized exchanges there is always some amount of slippage or loss in a transaction. Seeing .10-1% is not uncommon. This is how that plays out on transactions big and small."}</_components.p>{"\n"}{}{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 w-full text-base"><thead><tr><th className="px-4 w-1/3">{"Size"}</th><th className="px-4 w-1/3"><span className="whitespace-nowrap">{"Deposit Fee /"}</span>{" Slippage"}</th><th className="px-4 w-1/3">{"Cost"}</th></tr></thead><tbody>{attributes.slippage.map(s => <_components.tr key={s.slippage}>
          <_components.td className="px-4">{s.size}</_components.td>
          <_components.td className="px-4">{s.slippage}</_components.td>
          <_components.td className="px-4">{s.cost}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"When you compare the cost of using a business account with these fees the savings are obvious, and add up."}</_components.p>{"\n"}{}{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 w-full text-base"><thead><tr><th className="px-4">{"In"}</th><th className="px-4 w-1/4" /><th className="px-4 w-1/4">{"Out"}</th><th className="px-8 w-1/4 whitespace-nowrap">{"Fixed Cost"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"BP Cost"}</th></tr></thead><tbody>{attributes.swap.map((s, i) => <_components.tr key={i}>
          <_components.td className="px-4 whitespace-nowrap text-primary">
            <_components.div className="flex items-center">
              {s.in !== "USD" ? <_components.img alt={`${s.in} logo`} src={`/assets/stablecoins/${s.in.toLowerCase()}-logo.png`} className="h-6 w-6 inline-block !mr-2" /> : <FontAwesomeIcon icon={faCircleDollar} className="mr-2 text-green-600 dark:text-green-500 h-6 w-6" />}
              <_components.strong>{s.in}</_components.strong>
            </_components.div>
          </_components.td>
          <_components.td className="px-4 align-middle text-center">
            <FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" />
          </_components.td>
          <_components.td className="px-4 whitespace-nowrap text-primary">
            <_components.div className="flex items-center">
              {s.out !== "USD" ? <_components.img alt={`${s.out} logo`} src={`/assets/stablecoins/${s.out.toLowerCase()}-logo.png`} className="h-6 w-6 inline-block !mr-2" /> : <FontAwesomeIcon icon={faCircleDollar} className="mr-2 text-green-600 dark:text-green-500 h-6 w-6" />}
              <_components.strong>{s.out}</_components.strong>
            </_components.div>
          </_components.td>
          <_components.td className="px-8 align-middle">{s.fixedCost}</_components.td>
          <_components.td className="px-4 align-middle">{s.bpCost}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"These swaps not only work across stablecoins, but they also work cross chain. We support 10 today, going on a number of unannounced blockchain ecosystems."}</_components.p>{"\n"}<div className="flex sm:gap-4 lg:gap-4 py-4">{BLOCKCHAINS.map(b => <_components.img key={b.name} alt={`${b.name} logo`} src={b.icon} className="h-8 w-8 sm:h-10 sm:w-10 border border-primary rounded-full" />)}</div>{"\n"}<_components.h2>{"Generate cards for expenditures with fine-tuned controls"}</_components.h2>{"\n"}<_components.p>{"Thanks to our partnership with "}<ExternalLink title="Learn more about Rain" href="https://www.raincards.xyz/">{"Rain"}</ExternalLink>{", you can generate corporate cards for your business and spend your stablecoins anywhere VISA is accepted. Rain cards support Brale-issued (and non-Brale-issued) stablecoins natively. Generate spendable cards in the Rain UI."}</_components.p>{"\n"}<ImageSlider slides={attributes.slider.slides} settings={attributes.slider.settings} />{"\n"}<_components.h2>{"Run your business onchain and go offchain whenever you want"}</_components.h2>{"\n"}<_components.p>{"We’ve designed business accounts with pricing and features much like other financial accounts you use everyday in your business. Here are the pricing basics:"}</_components.p>{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-4"><table className="table-auto m-0 w-full text-base"><tbody>{attributes.pricing.map(p => <_components.tr key={p.item}>
          <_components.td className="px-4 w-1/2 text-primary font-semibold">{p.item}</_components.td>
          {p.item === "Automations" ? <_components.td className="px-4 w-1/2">
              <_components.a href="/contact" alt="Contact us">
                {p.price}
              </_components.a>
            </_components.td> : <_components.td className="px-4 w-1/2">{p.price}</_components.td>}
        </_components.tr>)}</tbody></table></div>{"\n"}{}{"\n"}<span className="not-prose text-gray-500 dark:text-gray-400 text-sm">{"*Brale bills for gas fee usage. Any transaction initiated that incurs a gas fee is accompanied by an estimate when initiating the transaction."}</span></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "introducing-brale-business-accounts.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    